import { SupportAttachmentInput, SupportComment, SupportTicket } from "./support";

export function mapSupportAttachments(raw: unknown): SupportAttachmentInput[] | undefined {
  if (!Array.isArray(raw)) return undefined;
  return raw.map((a: Record<string, unknown>) => ({
    fileUrl: String(a.fileUrl ?? a.FileUrl ?? ""),
    fileName: (a.fileName ?? a.FileName) as string | undefined,
    contentType: (a.contentType ?? a.ContentType) as string | undefined,
    sizeBytes: (a.sizeBytes ?? a.SizeBytes) as number | undefined,
  }));
}

export function mapSupportTicket(raw: Record<string, unknown>): SupportTicket {
  return {
    id: String(raw.id ?? raw.Id ?? ""),
    subject: String(raw.subject ?? raw.Subject ?? ""),
    message: String(raw.message ?? raw.Message ?? ""),
    status: String(raw.status ?? raw.Status ?? "open"),
    companyId: (raw.companyId ?? raw.CompanyId) as string | undefined,
    createdByUserId: String(raw.createdByUserId ?? raw.CreatedByUserId ?? ""),
    createdByDisplayName: (raw.createdByDisplayName ?? raw.CreatedByDisplayName) as
      | string
      | undefined,
    createdByRole: String(raw.createdByRole ?? raw.CreatedByRole ?? ""),
    visibility: String(raw.visibility ?? raw.Visibility ?? ""),
    escalatedAt: (raw.escalatedAt ?? raw.EscalatedAt) as string | undefined,
    createdAt: String(raw.createdAt ?? raw.CreatedAt ?? ""),
    updatedAt: String(raw.updatedAt ?? raw.UpdatedAt ?? ""),
    attachments: mapSupportAttachments(raw.attachments ?? raw.Attachments),
    canEscalate: Boolean(raw.canEscalate ?? raw.CanEscalate),
    canChangeStatus: Boolean(raw.canChangeStatus ?? raw.CanChangeStatus),
  };
}

export function mapSupportComment(raw: Record<string, unknown>): SupportComment {
  return {
    id: String(raw.id ?? raw.Id ?? ""),
    ticketId: String(raw.ticketId ?? raw.TicketId ?? ""),
    body: String(raw.body ?? raw.Body ?? ""),
    createdByUserId: String(raw.createdByUserId ?? raw.CreatedByUserId ?? ""),
    createdByDisplayName: (raw.createdByDisplayName ?? raw.CreatedByDisplayName) as
      | string
      | undefined,
    createdAt: String(raw.createdAt ?? raw.CreatedAt ?? ""),
    isOwnComment: Boolean(raw.isOwnComment ?? raw.IsOwnComment),
    attachments: mapSupportAttachments(raw.attachments ?? raw.Attachments)?.map((a) => ({
      fileUrl: a.fileUrl,
      fileName: a.fileName,
      contentType: a.contentType,
      sizeBytes: a.sizeBytes,
    })),
  };
}

/** Mirrors TicketDetailDialog status control visibility. */
export function shouldShowStatusControl(isAdmin: boolean, ticket: SupportTicket): boolean {
  return isAdmin || Boolean(ticket.canChangeStatus);
}

export function isStatusControlEnabled(ticket: SupportTicket): boolean {
  return Boolean(ticket.canChangeStatus);
}

/** Mirrors TicketDetailDialog escalate button visibility. */
export function shouldShowEscalateButton(ticket: SupportTicket): boolean {
  return Boolean(ticket.canEscalate);
}
